import React from "react";
import "./WomensHealthPage.css";

const WomensHealthPage = () => {
  const handleCallClick = () => {
    window.location.href = "tel:+917007512120";
  };

  const handleWhatsAppClick = () => {
    window.location.href = "https://wa.me/919118063939";
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:info@swasthmitra.com";
  };

  return (
    <>
      <div className="womensHealthSection">
        <h2>🌸 Health, Strength & Wellness — Just for Her</h2>
        <div className="womensHealthContent">
          <p>
            At <strong>SwasthMitra</strong>, we believe every woman deserves access to <strong>compassionate, trustworthy, and personalized healthcare</strong> — no matter her age or stage in life.
          </p>
          <p>
            From daily wellness to intimate care, from fertility support to menopause relief — we bring you a <strong>curated selection of genuine health products</strong> tailored specifically for women, all in one place.
          </p>
          <p>
            Delivered discreetly. Backed by science. Chosen with care.
          </p>

          <hr />

          <h3>🔹 Our Women’s Health Categories</h3>

          <div className="healthCategory">
            <h4>💊 <em>Daily Nutrition & Immunity</em></h4>
            <ul>
              <li>Women’s multivitamins</li>
              <li>Iron, calcium & folic acid supplements</li>
              <li>Immunity boosters for women</li>
            </ul>
            <div className="categoryNote">
              <p>Stay energized, strong, and protected — every day.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>♀ <em>Intimate & Personal Care</em></h4>
            <ul>
              <li>pH-balanced intimate washes</li>
              <li>UTI relief products</li>
              <li>Menstrual cups, pads & tampons</li>
              <li>Vaginal hygiene and wellness kits</li>
            </ul>
            <div className="categoryNote">
              <p>Gentle, effective care — for your comfort and confidence.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>💞 <em>Fertility & Reproductive Health</em></h4>
            <ul>
              <li>Ovulation kits & pregnancy test kits</li>
              <li>Fertility-boosting supplements</li>
              <li>Prenatal vitamins</li>
            </ul>
            <div className="categoryNote">
              <p>Supporting your journey to motherhood with science and care.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>🤱 <em>Pregnancy & Postpartum Care</em></h4>
            <ul>
              <li>Nutritional support during and after pregnancy</li>
              <li>Lactation supplements</li>
              <li>Breast pumps and nipple care</li>
              <li>Stretch mark creams and postpartum recovery products</li>
            </ul>
            <div className="categoryNote">
              <p>Because a healthy mom means a healthy baby.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>🔥 <em>Hormonal Balance & Menopause Support</em></h4>
            <ul>
              <li>PCOS/PCOD support supplements</li>
              <li>Menopause relief products</li>
              <li>Mood, bone & hormonal health support</li>
            </ul>
            <div className="categoryNote">
              <p>Embrace every phase of womanhood with strength and stability.</p>
            </div>
          </div>

          <div className="healthCategory">
            <h4>🧖‍♀ <em>Skin, Hair & Beauty Wellness</em></h4>
            <ul>
              <li>Hair fall control supplements</li>
              <li>Biotin, collagen, and skin glow capsules</li>
              <li>Anti-aging and acne care products</li>
            </ul>
            <div className="categoryNote">
              <p>Beauty from within — powered by nutrition.</p>
            </div>
          </div>

          <hr />

          <h3>🔒 Discreet. Safe. Supportive.</h3>
          <div className="benefits">
            <p>✅ <strong>Discreet packaging</strong></p>
            <p>✅ <strong>Certified, genuine products</strong> only</p>
            <p>✅ <strong>No judgment, just care</strong></p>
            <p>✅ Expert advice available on request</p>
          </div>

          <hr />

          <div className="helpSection">
            <h3>💬 Need Help Choosing?</h3>
            <p>
              We’re just a call or WhatsApp away.
              <br />
              Our team is ready to help you pick the right products for your specific needs — with complete confidentiality and empathy.
            </p>
            <div className="contactButtons">
              <button className="callButton" onClick={handleCallClick}>📞 Call: +91-7007512120</button>
              <button className="emailButton" onClick={handleEmailClick}>📧 Email: info@swasthmitra.com</button>
              <button className="whatsappButton" onClick={handleWhatsAppClick}>💬 Chat with Us on WhatsApp</button>
            </div>
          </div>

          <div className="closingSection">
            <h3>🌺 Because You Deserve Care That Understands You</h3>
            <p>
              At SwasthMitra, we’re not just a pharmacy — we’re a health partner that truly cares.
              <br />
              Explore our handpicked women’s health range and take charge of your wellness journey.
            </p>
          
          </div>
        </div>
      </div>
    </>
  );
};

export default WomensHealthPage;